
      import { checkLoafSupport } from "/main.js";

      const triggerBtn = document.getElementById("triggerBtn");
      const clearBtn = document.getElementById("clearBtn");
      const longTaskOutput = document.getElementById("longTaskOutput");
      const loafOutput = document.getElementById("loafOutput");
      const comparison = document.getElementById("comparison");

      checkLoafSupport();

      let longTaskData = null;
      let loafData = null;

      // Helper para crear logger por output
      function createLogger(container) {
        return {
          log(msg, color = "inherit") {
            const line = document.createElement("div");
            line.style.color = color;
            line.textContent = msg;
            container.appendChild(line);
          },
          warn(msg) {
            this.log(msg, "var(--color-warning)");
          },
          error(msg) {
            this.log(msg, "var(--color-danger)");
          },
          clear() {
            container.innerHTML = "";
          },
        };
      }

      const longTaskLogger = createLogger(longTaskOutput);
      const loafLogger = createLogger(loafOutput);

      // Observer de Long Tasks
      const longTaskObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          longTaskLogger.log("");
          longTaskLogger.log("═══ LONG TASK DETECTADA ═══");
          longTaskLogger.log("");
          longTaskLogger.log(`Duration: ${entry.duration.toFixed(2)}ms`);
          longTaskLogger.log(`Start time: ${entry.startTime.toFixed(2)}ms`);
          longTaskLogger.log(`Name: ${entry.name}`);
          longTaskLogger.log("");

          if (entry.attribution && entry.attribution.length > 0) {
            longTaskLogger.log("Attribution:");
            entry.attribution.forEach((attr, i) => {
              longTaskLogger.log(`  ${i + 1}. Type: ${attr.containerType}`);
              longTaskLogger.log(`     Name: ${attr.name || "(unknown)"}`);
            });
          }

          longTaskLogger.log("");
          longTaskLogger.warn("⚠️  Información limitada");
          longTaskLogger.warn("No sabemos qué script causó esto");
          longTaskLogger.log("");

          // Guardar para comparación
          longTaskData = {
            duration: entry.duration,
            startTime: entry.startTime,
            name: entry.name,
            hasScriptInfo: false,
            hasForcedLayout: false,
          };

          updateComparison();
        }
      });

      try {
        longTaskObserver.observe({ type: "longtask", buffered: true });
        longTaskLogger.log("✅ Long Tasks observer activo");
        longTaskLogger.log("");
      } catch (e) {
        longTaskLogger.error("❌ Long Tasks API no soportada");
      }

      // Observer de LoAF
      const loafObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          loafLogger.log("");
          loafLogger.log("═══ LONG ANIMATION FRAME ═══");
          loafLogger.log("");
          loafLogger.log(`Duration: ${entry.duration.toFixed(2)}ms`);
          loafLogger.log(`Blocking: ${entry.blockingDuration.toFixed(2)}ms`);
          loafLogger.log(`Start time: ${entry.startTime.toFixed(2)}ms`);
          loafLogger.log(`Render start: ${entry.renderStart.toFixed(2)}ms`);
          loafLogger.log("");

          if (entry.scripts && entry.scripts.length > 0) {
            loafLogger.log(`Scripts: ${entry.scripts.length}`);
            loafLogger.log("");

            entry.scripts.forEach((script, i) => {
              loafLogger.log(`Script #${i + 1}:`);
              loafLogger.log(`  Función: ${script.sourceFunctionName || "(anónima)"}`);
              loafLogger.log(`  Invoker: ${script.invoker || "N/A"}`);
              loafLogger.log(`  Duration: ${script.duration.toFixed(2)}ms`);
              loafLogger.log(
                `  Forced layout: ${script.forcedStyleAndLayoutDuration.toFixed(2)}ms`,
              );

              if (script.sourceURL) {
                loafLogger.log(`  URL: ${script.sourceURL}`);
              }

              loafLogger.log("");
            });
          }

          loafLogger.log("✅ Información completa disponible", "var(--color-success)");
          loafLogger.log("");

          // Guardar para comparación
          loafData = {
            duration: entry.duration,
            startTime: entry.startTime,
            blockingDuration: entry.blockingDuration,
            hasScriptInfo: entry.scripts.length > 0,
            scriptName: entry.scripts[0]?.sourceFunctionName || null,
            hasForcedLayout: entry.scripts[0]?.forcedStyleAndLayoutDuration > 0,
          };

          updateComparison();
        }
      });

      try {
        loafObserver.observe({ type: "long-animation-frame", buffered: true });
        loafLogger.log("✅ LoAF observer activo");
        loafLogger.log("");
      } catch (e) {
        loafLogger.error("❌ LoAF API no soportada");
      }

      function updateComparison() {
        if (!longTaskData || !loafData) return;

        const infoGained = [];

        if (loafData.hasScriptInfo) {
          infoGained.push(`✅ Nombre de función: ${loafData.scriptName}`);
        }

        if (loafData.blockingDuration) {
          infoGained.push(`✅ Blocking duration: ${loafData.blockingDuration.toFixed(2)}ms`);
        }

        if (loafData.hasForcedLayout) {
          infoGained.push("✅ Información de forced layout disponible");
        }

        comparison.innerHTML = `
        <div style="margin-top: 0.5rem;">
          <strong>Long Tasks API:</strong>
          <div style="color: var(--color-danger); margin: 0.5rem 0;">
            ❌ Solo sabemos que hubo una tarea de ${longTaskData.duration.toFixed(2)}ms<br>
            ❌ No sabemos qué la causó
          </div>

          <strong>Long Animation Frames API:</strong>
          <div style="color: var(--color-success); margin: 0.5rem 0;">
            ${infoGained.join("<br>")}
          </div>

          <div style="background: var(--color-bg-secondary); padding: 1rem; border-radius: 4px; margin-top: 1rem;">
            <strong>📊 Información adicional obtenida con LoAF:</strong><br>
            <span style="color: var(--color-primary); font-weight: bold;">
              ${infoGained.length} datos extra que permiten debugging efectivo
            </span>
          </div>
        </div>
      `;
      }

      // Botón para generar tarea lenta
      triggerBtn.addEventListener("click", function generateLongTask() {
        longTaskLogger.log("🔵 Generando tarea lenta...");
        loafLogger.log("🔵 Generando tarea lenta...");

        // Reset data
        longTaskData = null;
        loafData = null;
        comparison.textContent = "Esperando detección...";

        // Tarea pesada que bloqueará el main thread
        const start = performance.now();
        let result = 0;

        while (performance.now() - start < 200) {
          for (let i = 0; i < 1000; i++) {
            result += Math.sqrt(i) * Math.random();
          }
        }

        longTaskLogger.log("✅ Tarea completada");
        longTaskLogger.log("⏳ Esperando Long Tasks API...");
        longTaskLogger.log("");

        loafLogger.log("✅ Tarea completada");
        loafLogger.log("⏳ Esperando LoAF API...");
        loafLogger.log("");
      });

      // Limpiar
      clearBtn.addEventListener("click", () => {
        longTaskLogger.clear();
        loafLogger.clear();
        longTaskData = null;
        loafData = null;
        comparison.textContent = "Haz clic en el botón para comparar ambas APIs";

        longTaskLogger.log("✅ Long Tasks observer activo");
        longTaskLogger.log("");
        loafLogger.log("✅ LoAF observer activo");
        loafLogger.log("");
      });

      // Mensaje inicial
      longTaskLogger.log("👋 Haz clic en el botón para comparar");
      longTaskLogger.log("");
      loafLogger.log("👋 Haz clic en el botón para comparar");
      loafLogger.log("");
    